<template>
  <div
    class="bg-surface-default-low rounded-full caption flex w-fit items-center space-x-4 p-4 pr-8 md:body-2"
  >
    <component :is="icon" class="h-16 w-16 shrink-0" />
    <p>{{ label }}</p>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{ icon: Component; label: string }>()
</script>
